import React from 'react'
import './Faq.css';
import accimg from '../Images/about-07.webp'

const Faq = () => {
    return (
        <section className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
                {/* Outer Border Container */}
                <div className="border-2 border-orange-200 rounded-3xl p-8 bg-white shadow-sm hover:shadow-md transition-shadow duration-300">
                    <div className="text-center mb-12">
                        <h1 className="text-3xl lg:text-4xl font-bold text-gray-800">
                            FAQs on Courses After 12th
                        </h1>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
                        <div className="space-y-4">
                            <details className="bg-gray-50 shadow-sm rounded-lg p-4 cursor-pointer hover:shadow-md transition border border-gray-100">
                                <summary className="font-semibold text-lg text-gray-800 cursor-pointer">What are the popular courses I can pursue after 12th science?</summary>
                                <div className="mt-4 text-gray-600 leading-relaxed">
                                    <p>After completing 12th grade with a science stream, you have a wide range of options, including:</p>
                                    <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                                        <li>Engineering (B.Tech/B.E.) in various fields like Computer Science</li>
                                        <li>Mechanical, Electrical, Civil, etc.</li>
                                        <li>Medical (MBBS, BDS, BAMS, BHMS)</li>
                                        <li>Pure Sciences (B.Sc.) in Physics, Chemistry, Biology, Mathematics</li>
                                        <li>Nursing (B.Sc. Nursing)</li>
                                        <li>Pharmacy (B.Pharm)</li>
                                        <li>Architecture (B.Arch)</li>
                                    </ul>
                                </div>
                            </details>

                            <details className="bg-gray-50 shadow-sm rounded-lg p-4 cursor-pointer hover:shadow-md transition border border-gray-100">
                                <summary className="font-semibold text-lg text-gray-800 cursor-pointer">What are the career options available after 12th commerce?</summary>
                                <div className="mt-4 text-gray-600 leading-relaxed">
                                    <p>Commerce students can explore:</p>
                                    <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                                        <li>B.Com (Bachelor of Commerce)</li>
                                        <li>BBA (Bachelor of Business Administration)</li>
                                        <li>CA (Chartered Accountancy)</li>
                                        <li>CS (Company Secretary)</li>
                                        <li>CMA (Cost and Management Accounting)</li>
                                        <li>Economics (B.A. in Economics)</li>
                                        <li>Finance and Accounting courses</li>
                                    </ul>
                                </div>
                            </details>

                            <details className="bg-gray-50 shadow-sm rounded-lg p-4 cursor-pointer hover:shadow-md transition border border-gray-100">
                                <summary className="font-semibold text-lg text-gray-800 cursor-pointer">What are the best courses for students who completed 12th in arts/humanities?</summary>
                                <div className="mt-4 text-gray-600 leading-relaxed">
                                    <p>Arts and humanities students have a plethora of courses to choose from, including:</p>
                                    <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                                        <li>B.A. (Bachelor of Arts) in subjects like Psychology, Sociology, History, Political Science, English Literature</li>
                                        <li>Journalism and Mass Communication (B.A. or B.J.M.C)</li>
                                        <li>Law (Integrated LLB)</li>
                                        <li>Design and Fine Arts (BFA, B.Des)</li>
                                        <li>Nursing (B.Sc. Nursing)</li>
                                        <li>Education (B.Ed.)</li>
                                        <li>Social Work (B.S.W.)</li>
                                    </ul>
                                </div>
                            </details>

                            <details className="bg-gray-50 shadow-sm rounded-lg p-4 cursor-pointer hover:shadow-md transition border border-gray-100">
                                <summary className="font-semibold text-lg text-gray-800 cursor-pointer">Are there any vocational courses available after 12th?</summary>
                                <div className="mt-4 text-gray-600 leading-relaxed">
                                    <p>Yes, there are several vocational courses designed to provide practical skills and training for specific careers:</p>
                                    <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                                        <li>Hotel Management (BHM)</li>
                                        <li>Event Management (BBA in Event Management)</li>
                                        <li>Travel and Tourism Management (BBA or BTTM)</li>
                                        <li>Animation and Multimedia</li>
                                        <li>Fashion Design</li>
                                        <li>Culinary Arts</li>
                                    </ul>
                                </div>
                            </details>

                            <details className="bg-gray-50 shadow-sm rounded-lg p-4 cursor-pointer hover:shadow-md transition border border-gray-100">
                                <summary className="font-semibold text-lg text-gray-800 cursor-pointer">How do I choose the right course after 12th?</summary>
                                <div className="mt-4 text-gray-600 leading-relaxed">
                                    <p>Choosing the right course depends on your interests, strengths, and career goals. Consider factors like:</p>
                                    <ul className="list-disc list-inside mt-2 space-y-1 text-sm">
                                        <li>Your aptitude and interests</li>
                                        <li>Career prospects and job opportunities</li>
                                        <li>Industry growth and demand</li>
                                        <li>Course duration and fee structure</li>
                                        <li>Consult career counselors and take aptitude tests</li>
                                    </ul>
                                </div>
                            </details>
                        </div>

                        <div className="flex items-center justify-center">
                            <img src={accimg} alt="Education FAQ" className="w-3/4 rounded-2xl shadow-lg" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;
